<modal-form #modalForm (action)="emailForm.ngSubmit.emit()" [isValid]="emailForm.form.valid" [disableOk]="!emailForm.form.valid" [isDirty]="emailForm.form.dirty" (validationFailed)="emailInput.control.markAsDirty();">
  <span form-header>Email Recordable</span>
  <div form-body>
    <form #emailForm="ngForm" (ngSubmit)="sendEmail()">
      <div class="form-group">
        <label for="emailInput"><strong>To Email Address(es)</strong>&nbsp;<small class="text-muted"><i>Enter mulitple email addresses separated by a comma.</i></small></label>
        <input type="email" class="form-control" id="emailInput" #emailInput="ngModel" name="email" multiple="multiple" required [(ngModel)]="emailAddresses" placeholder="john@john.com,pulte@pulte.com" pattern="^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},*[\W]*)+$">
        @if (emailInput.invalid && emailInput.dirty) {
          <div class="validation-error">
            @if (emailInput.errors.required) {
              <span>This field is required!</span>
            }
            @if (!emailInput.valid && !emailInput.errors.required) {
              <span>Please enter valid email addresses separated by a comma.</span>
            }
          </div>
        }
      </div>
      <div class="form-group">
        <label for="subjectInput"><strong>Subject</strong></label>
        <input type="text" class="form-control" id="subjectInput" #subjectInput="ngModel" name="subjectInput" required [(ngModel)]="emailSubject">
        @if (subjectInput.invalid && subjectInput.dirty) {
          <div class="validation-error">
            @if (emailInput.errors.required) {
              <span>This field is required!</span>
            }
          </div>
        }
      </div>
      <div class="form-group">
        <label><strong>Email Body</strong></label>
        <p-editor [(ngModel)]="emailBody" [ngModelOptions]="{standalone: true}" [style]="{'height':'275px'}">
          <p-header>
            <span class="ql-formats">
              <button class="ql-bold" aria-label="Bold"></button>
              <button class="ql-italic" aria-label="Italic"></button>
              <button class="ql-underline" aria-label="Underline"></button>
            </span>
          </p-header>
        </p-editor>
      </div>
    </form>
  </div>
</modal-form>